<template>
 <vue-tel-input 
  style="width: 100%; padding: 10px 5px;" 
  v-model="phone"
  :mode="'international'" 
  :valid-characters-only="true" 
  :dropdown-options="{showSearchBox: true , showFlags: true}"
  :input-options="{ placeholder: placeholder }" 
  :autoFormat="false" 
  :auto-validate="false"
  @on-input="handleInput"
 
></vue-tel-input>
</template>

<script>
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import { mapGetters } from "vuex";

export default {
  components: {
    VueTelInput,
  },

  data() {
    return {
      phone: null,
      isDisabled: false,
      validPhone: true,
      mode: "international", // could be 'national'
      autoDefaultCountry: "ُEG", // set default country
      validCharactersOnly: true, // only valid characters allowed
      maxLength: 15, // max length for the phone input
      phoneData: {
        phoneNumber: "",
        countryCode: "",
        isValid: false,
      },
    };
  },
  computed: {
    ...mapGetters(["currentLanguage"]),
    placeholder() {
      return this.currentLanguage === "en"
        ? "Enter your phone number" // English placeholder
        : "أدخل رقم هاتفك"; // Arabic placeholder
    },
  },
  watch: {
    phone(newPhone) {
      this.$emit("handlePhoneInput", newPhone); // Emit phone data to the parent when it changes
    },
  },

  methods: {
    handleInput(number , phoneObject) {
      // Access the phone number and phoneObject here 
      // Optionally, you can store the values
      this.$emit("update-phone",number , phoneObject);
    },
    /*handlePhoneInput(newPhone) {
      console.log(newPhone);
      this.$emit("update-phone", newPhone); // Emit phone data to the parent
    },
    handleValidate(phoneObject) {
      this.phoneData = {
        phoneNumber: phoneObject.number,
        countryCode: phoneObject.country,
        isValid: phoneObject.valid,
      };
      //console.log(phoneObject);
      this.$emit("validate-phone", this.phoneData);
    },*/
  },
};
</script>

<style scoped>
/* Add any specific styles you want for the component */
.vti__input {
  font-size: 14px;
}
</style>